import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Resolve stored image references: absolute URLs pass through; "/api/files/..." get the backend prefix.
export const mediaUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http://") || u.startsWith("https://") || u.startsWith("data:") || u.startsWith("blob:")) return u;
  return `${BACKEND_URL}${u.startsWith("/") ? "" : "/"}${u}`;
};

export const COMPANY = {
  name: "West Face Roofing",
  tagline: "The Roofing Specialists",
  subtagline: "Affordable prices with quality workmanship.",
  phone: "08 9247 2962",
  phoneHref: "tel:+61892472962",
  email: "info@westfaceroofing.com.au",
  area: "Perth, Western Australia",
  address: "Coode Street, South Perth WA 6151",
  since: 2010,
  hours: "Mon–Fri 7am–5pm · Sat 8am–1pm",
};

import { useState, useEffect } from "react";

export const HERO_BEFORE = "https://d8j0ntlcm91z4.cloudfront.net/user_3E43AAMjApkadPXKoyxwB6VdRzL/hf_20260715_112657_84f5a4da-f6fd-4f7e-b74e-8b5451b6a1ba.png";
export const HERO_AFTER = "https://d8j0ntlcm91z4.cloudfront.net/user_3E43AAMjApkadPXKoyxwB6VdRzL/hf_20260715_113952_e2fdfd45-2907-444b-a650-c09bcaa006f1.png";

const SITE_DEFAULTS = {
  hero_before_url: HERO_BEFORE,
  hero_after_url: HERO_AFTER,
  hero_headline: "The Roofing Specialists",
  service_area_text: "Servicing all of Perth — within 20 km of South Perth.",
  service_area_radius_km: 20,
  phone: COMPANY.phone,
  email: COMPANY.email,
  address: COMPANY.address,
  reviews_enabled: true,
  pm_strata_page: {
    headline: "Your roofing partner for Perth's property & strata portfolios.",
    offer_items: [],
    cta_text: "Book a portfolio roof report",
  },
};

// Fetch the published site content (single source of truth). Never renders blank.
export function useSiteContent() {
  const [content, setContent] = useState(SITE_DEFAULTS);
  useEffect(() => {
    api.get("/site-content")
      .then((r) => setContent({ ...SITE_DEFAULTS, ...r.data }))
      .catch(() => {});
  }, []);
  return content;
}
